/**
 * Display-only merge: fold related product offers into the main PDP price list.
 * Key = main product slug. Related products stay separate canonical rows in Supabase.
 */
export const MERGE_RELATED_OFFERS_BY_SLUG = {
  'livescope-plus-lvs34': [
    {
      slug: 'livescope-plus-lvs34-ice',
      sourceDisplay: 'Scheels',
      variantInfo: [
        'LVS34 is the standard open-water LiveScope Plus system.',
        'LVS34-IF is the ice fishing version.',
        'The IF package includes the LVS34-IF transducer with a cold-weather flexible cable.',
        'It is a different Garmin SKU/package. Pick the one that matches how you fish.',
      ],
    },
  ],
};

export function getMergeRelatedOfferConfigsForSlug(slug) {
  if (!slug || typeof slug !== 'string') return [];
  return MERGE_RELATED_OFFERS_BY_SLUG[slug.trim()] ?? [];
}
